<template>
  <div class="container upcoming-content home-p-color">
    <pp-steps :step="2" />

    <div class="content center-margin">
      <div class="step">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          :label-position="labelPosition"
          class="demo-ruleForm"
        >
          <input style="display:none"><input
            type="password"
            style="display:none"
          >
          <el-form-item
            :label="$t('ppwc.p8')"
            prop="serial_no"
          >
            <el-input
              v-model="ruleForm.serial_no"
              :placeholder="$t('ppwc.p8')"
              class="serial_input"
              :disabled="true"
            />
          </el-form-item>
          <div class="infomation">
            <p>*{{ $t('ppwc.p16') }}</p>
          </div>
          <el-form-item
            :label="$t('ppwc.p20')"
            prop="name"
          >
            <el-input
              v-model="ruleForm.name"
              :placeholder="$t('ppwc.p20')"
              class="name_input"
            />
          </el-form-item>
          <el-form-item
            :label="$t('ppwc.p23')"
            style="margin-bottom: 0px;"
          >
            <el-col :span="24">
              <el-col :span="8">
                <el-form-item prop="id_type">
                  <el-select
                    v-model="ruleForm.id_type"
                    :placeholder="$t('ppwc.p23')"
                  >
                    <el-option
                      :label="$t('ppwc.p24')"
                      value="1"
                    />
                    <el-option
                      :label="$t('ppwc.p25')"
                      value="2"
                    />
                    <el-option
                      :label="$t('ppwc.p26')"
                      value="3"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="16"
                style="padding-left: 4px;"
              >
                <el-form-item prop="id_num">
                  <el-input
                    v-model="ruleForm.id_num"
                    :placeholder="$t('ppwc.p27')"
                    class="id_num_input"
                  />
                </el-form-item>
              </el-col>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('ppwc.p28')"
            prop="platform"
          >
            <el-select
              v-model="ruleForm.platform"
              filterable
              :placeholder="$t('ppwc.p29')"
              style="width: 100%;"
              class="platform_input"
              @change="changePlatform"
            >
              <el-option
                v-for="item in platforms"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('ppwc.p33')"
            prop="date"
          >
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="$t('ppwc.p34')"
              style="width: 100%;"
              class="date_input"
            />
          </el-form-item>
          <el-form-item
            :label="$t('ppwc.p106')"
            prop="preferred"
          >
            <el-select
              v-model="ruleForm.preferred"
              :placeholder="$t('ppwc.p38')"
              style="width: 100%;"
              class="preferred_input"
            >
              <el-option
                :label="$t('ppwc.p40')"
                value="1"
              />
              <el-option
                :label="$t('ppwc.p41')"
                value="2"
              />
              <el-option
                :label="$t('ppwc.p42')"
                value="3"
              />
              <el-option
                :label="$t('ppwc.p43')"
                value="4"
              />
              <el-option
                :label="$t('ppwc.p44')"
                value="5"
              />
              <el-option
                :label="$t('ppwc.p45')"
                value="6"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('ppwc.p14')"
            prop="email"
          >
            <el-input
              v-model="ruleForm.email"
              :placeholder="$t('ppwc.p14')"
              class="email_input"
            />
          </el-form-item>
          <el-form-item
            prop="agreement"
            style="margin-bottom: 0px;"
            class="div_checkbox"
          >
            <el-checkbox
              v-model="ruleForm.agreement"
              :class="{ error: (!ruleForm.agreement && agreementError) }"
            >
              {{ $t('ppwc.p36') | format }} <a
                href="/user-agreement"
                target="_blank"
              >{{ $t('ppwc.p37') }}</a>
            </el-checkbox>
            <div>
              <el-checkbox
                v-if="showAgreement2"
                v-model="ruleForm.agreement2"
                :class="{ error: (!ruleForm.agreement2 && agreementError) }"
              >
                {{ $t('ppwc.p36') | format }} <a
                  href="/privacy-policy"
                  target="_blank"
                >{{ $t('ppwc.p47') }}</a>
              </el-checkbox>
            </div>
          </el-form-item>
          <el-form-item>
            <div
              class="confirm"
              @click="submitForm('ruleForm')"
            >
              <p>{{ $t('ppwc.p12') }}</p>
            </div>
          </el-form-item>
        </el-form>
        <p v-if="tips">
          {{ tips }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPlatforms
} from '@/api/official'
import ppSteps from './ppSteps'
import moment from 'moment'

export default {
  components: {
    ppSteps
  },
  filters: {
    format: function(val) {
      return val.replace('{link}', '')
    }
  },
  data() {
    var checkDate = (rule, value, callback) => {
      let now = moment().subtract(18, 'y').format('YYYY-MM-DD')
        console.log(value, now)

      if(moment(value).isAfter(now)) {
        callback(new Error(this.$t('ppwc.p70')))
      }else {
        callback()
      }
    }
    var checkEmail = (rule, value, callback) => {
      var reg = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
      if (!reg.test(value)) {
        callback(new Error(this.$t('ppwc.p15')))
      } else {
        callback()
      }
    }
    return {
      labelPosition: 'top',
      tips: '',
      ruleForm: {
        serial_no: '',
        email: '',
        name: '',
        id_type: '1',
        id_num: '',
        platform: '',
        date: '',
        preferred: '',
        agreement: false,
        agreement2: false
      },
      agreementError: false,
      platforms: null,
      showAgreement2: false,
      rules: {
        serial_no: [
          { required: true, message: this.$t('ppwc.p17'), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$t('ppwc.p18'), trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('ppwc.p19'), trigger: 'blur' },
        ],
        id_num: [
          { required: true, message: this.$t('ppwc.p21'), trigger: 'blur' },
        ],
        platform: [
          { required: true, message: this.$t('ppwc.p30'), trigger: 'change' },
        ],
        date: [
          { required: true, message: this.$t('ppwc.p35'), trigger: 'blur' },
          { validator: checkDate, trigger: 'blur' }
        ],
        preferred: [
          { required: true, message: this.$t('ppwc.p39'), trigger: 'change' },
        ],
        // agreement: [
        //   { required: true, message: 'Please read the User Agreement', trigger: 'change' },
        // ],
      }
    }
  },
  created() {
    // this.ruleForm.serial_no = this.$route.query.serial_no
    this.ruleForm = this.$route.query
    if(this.$route.query.agreement) {
      this.ruleForm.agreement = !!this.$route.query.agreement
    }
    if(this.$route.query.agreement2) {
      this.ruleForm.agreement2 = !!this.$route.query.agreement2
    }
    if(!this.ruleForm.id_type) {
      this.ruleForm.id_type = '1'
    }
    if(this.ruleForm.platform) {
      this.changePlatform(this.ruleForm.platform)
    }
    this.getlist()
  },
  methods: {
    getlist() {
      getPlatforms()
        .then(res => {
          if(res.code == 0) {
            this.platforms = res.data
          }
        })
        .catch(err => {
          alert('network issue, Please try again later.')
        })
    },
    changePlatform(val) {
      let temp = [ 'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Republic of Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden and the UK.']
      this.showAgreement2 = temp.some(v => {
        return v === val
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.ruleForm.agreement || (!this.ruleForm.agreement2 && this.showAgreement2)) {
            this.agreementError = true
          }else {
            let idType = {
              '1': this.$t('ppwc.p24'),
              '2': this.$t('ppwc.p25'),
              '3': this.$t('ppwc.p26')
            }
            let preferredType = {
              '1': this.$t('ppwc.p40'),
              '2': this.$t('ppwc.p41'),
              '3': this.$t('ppwc.p42'),
              '4': this.$t('ppwc.p43'),
              '5': this.$t('ppwc.p44'),
              '6': this.$t('ppwc.p45')
            }
            this.ruleForm.idTypeTxt = idType[this.ruleForm.id_type]
            this.ruleForm.preferredTypeTxt = preferredType[this.ruleForm.preferred]
            this.ruleForm.birthday = this.ruleForm.date
            this.ruleForm.lang = this.$i18n.locale

            console.log('form2 data is ', this.ruleForm)
            console.log(this.ruleForm.date)
            this.$emit('setStep', 3, this.ruleForm)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.banner_img {
  height: 410px;
  background: url("/official/static/img/events/banner1.jpg") center center;
  background-repeat: no-repeat;
}
.upcoming-content {
  padding-top: 65px;
  padding-bottom: 65px;
  .content {
    width: 620px;
  }
}
.step {
  /deep/.demo-ruleForm {
    input::-webkit-input-placeholder{   /* 使用webkit内核的浏览器 */
      font-weight: normal;
    }
    input:-moz-placeholder{    /* Firefox版本4-18 */
      font-weight: normal;
      color: #C0C4CC;
    }
    input::-moz-placeholder{    /* Firefox版本19+ */
      font-weight: normal;
      color: #C0C4CC;
    }
    input:-ms-input-placeholder{   /* IE浏览器 */
      font-weight: normal;
      color: #C0C4CC;
    }
  }
  .demo-ruleForm {
    .el-form-item {
      margin-bottom: 26px;
    }
    .div_checkbox {
      a {
        color: #4092de;
      }
      /deep/.el-form-item__content {
        line-height: 26px;
      }
    }
    /deep/.el-input__inner {
      font-weight: bold;
      font-size: 18px;
      height: 54px;
      color: #1f9d56;
    }
    /deep/.el-form-item__error {
      font-weight: bold;
    }
    /deep/.el-select .el-input .el-select__caret {
      color: #686868;
    }
    /deep/.el-form-item__label {
      color: #686868;
      font-weight: bold;
      font-size: 18px;
      padding: 0px;
      line-height: 30px;
    }
    /deep/.el-form-item__label:before {
      display: none;
    }
    /deep/.el-checkbox__label {
      font-size: 16px;
      a {
        box-shadow: 0 1PX;
      }
    }
    /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
      font-size: 16px;
      color: #606266;
    }
    /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #1f9d56;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #1f9d56;
      border-color: #1f9d56;
    }
    /deep/.el-checkbox__inner:hover {
      border-color: #1f9d56;
    }
    /deep/.el-checkbox {
      font-size: 16px;
      line-height: 26px;
    }
    /deep/.el-date-table td.current:not(.disabled) span {
      background-color: #1f9d56;
    }
    /deep/.el-date-table td.today span {
      color: #1f9d56;
    }
    /deep/.el-checkbox.error {
      .el-checkbox__inner {
        border-color: #942321;
      }
      .el-checkbox__label {
        color: #942321;
        a {
          color: #942321;
        }
      }
    }
    /deep/.el-form-item.is-error {
      .el-input__inner {
        color: #942321;
        font-weight: normal;
      }
    }
    .serial_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/1/no_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .email_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/email_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .name_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/name_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .id_num_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/id_type.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .platform_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/nationality.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .preferred_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/chip.png') no-repeat 14px center;
        background-size: 22px auto;
      }
    }
    .date_input {
      /deep/.el-input__inner {
        padding-left: 45px;
        background: url('/official/static/img/events/activate/2/date_g.png') no-repeat 14px center;
        background-size: 22px auto;
      }
      /deep/.el-input__icon {
        display: none;
      }
    }
    .infomation {
      display: inline-block;
      padding: 0px 0px;
      margin-bottom: 10px;
      // border: 1px solid #1f9d56;
      p {
        margin: 0px;
        font-size: 14px;
        line-height: 20px;
        color: #1f9d56;
      }
    }
  }
  .confirm {
    width: 223px;
    height: 42px;
    margin: 30px auto 0px auto;
    background: url('/official/static/img/events/activate/banner_01.png') no-repeat center center;
    cursor: pointer;
    p {
      text-align: center;
      line-height: 42px;
      font-size: 24px;
      color: #fff;
    }
  }
}
</style>
